module.exports = __webpack_public_path__ + "img/cboi-cru.62afec7.webp";